import Cookies from "js-cookie";
import { decodeAuth } from "utils/Helper";

const getLocalAuth = Cookies.get("vb\C#^*gW589");
const dcode = getLocalAuth ? decodeAuth(getLocalAuth): null;

export const matches_config = {
    body: true,
    moung: true,
    half_time: true,
    even: true,
    odd: true,
    _1x2: true,
    correct_scores: true,
}

export const report_noti_roles = ['admin', 'super'];

export const onlyFootballAcceptUsercodes = ['SZ'];
export const isStartWithUsercode = onlyFootballAcceptUsercodes.some(uc => dcode?.user?.usercode?.startsWith(uc));